/* =========================================================
   WWC — Materiaal-groepering op de collectiepagina
   ---------------------------------------------------------
   Voegt productkaarten die hetzelfde product in een ander
   materiaal zijn samen tot één kaart met materiaal-bolletjes.

   Bronnen (allemaal taal-onafhankelijk, gezet in
   snippets/product-grid-item.liquid):
     data-wwc-group              → serie (_alt_-tag, genormaliseerd)
     data-wwc-material           → materiaal van dít product
     data-wwc-variant-materials  → materialen uit de variant-optie
     data-wwc-type / -price

   De zichtbare kaart blijft de eerste in de DOM, zodat de
   collectievolgorde van Shopify de positie bepaalt. Alleen de
   inhoud (foto, prijs, link) volgt het gekozen materiaal.
========================================================= */

(function () {
  'use strict';

  // :not([data-wwc-insert]) - een handmatig ingevoegd product is GEEN
  // groepskandidaat. Zonder deze uitsluiting vouwt de module bijvoorbeeld de
  // Citymap Generator samen met zijn soortgenoten en verdwijnt hij achter een
  // bolletje, precies waar hij juist moest opvallen.
  var CARD_SELECTOR = '.grid-product[data-product-handle]:not([data-wwc-insert])';

  /* ── Kern: pure functies, los van de DOM ────────────────────────────────── */

  /* Materiaalnamen vertalen.

     De namen komen uit de productdata en staan daar in het Nederlands. Op /en
     las de kaart daardoor "Serving board - 36.5 x 20 cm - Beuken": twee derde
     Engels en dan ineens een Nederlands woord. De vertaaltabel komt per taal
     uit de sectie mee; staat een materiaal er niet in, dan blijft de
     oorspronkelijke naam staan - liever het bronwoord dan een gat. */
  function vertaalMateriaal(naam, cfg) {
    if (!naam) return naam;
    // LET OP: `labels.materials` bestond al en bevat het WOORD "materialen"
    // (voor de vlag "8 materialen"). De vertaaltabel heet daarom materialNames;
    // op de oude sleutel gaf tabel[naam] undefined en bleef alles Nederlands.
    var tabel = (cfg && cfg.labels && cfg.labels.materialNames) || {};
    return tabel[naam] || naam;
  }

  function materialClass(name) {
    return String(name || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function orderIndex(name, order) {
    var i = order.indexOf(name);
    return i < 0 ? order.length + 1 : i;
  }

  function sortOptions(options, order) {
    return options.slice().sort(function (a, b) {
      return orderIndex(a.material, order) - orderIndex(b.material, order) || a.price - b.price;
    });
  }

  function pickHero(options, mode, forced) {
    if (forced) {
      var hit = options.filter(function (o) { return o.material === forced; })[0];
      if (hit) return hit;
    }
    if (mode === 'cheapest') {
      return options.reduce(function (a, b) { return b.price < a.price ? b : a; }, options[0]);
    }
    return options[0];
  }

  function minPrice(options) {
    return options.reduce(function (m, o) { return o.price < m ? o.price : m; }, options[0].price);
  }

  /* ── Config + context ───────────────────────────────────────────────────── */

  function readConfig(section) {
    var el = section.querySelector('[data-wwc-groups-config]');
    if (!el) return null;
    var cfg;
    try { cfg = JSON.parse(el.textContent || '{}'); } catch (e) { return null; }

    // De instellingen komen als komma-lijst uit de theme-editor; spaties eromheen
    // zijn menselijk en mogen de vergelijking niet breken.
    var trim = function (list) {
      return (list || []).map(function (s) { return String(s).trim(); }).filter(Boolean);
    };
    cfg.materialOrder = trim(cfg.materialOrder);
    cfg.acrylMaterials = trim(cfg.acrylMaterials);
    cfg.typeOrder = trim(cfg.typeOrder);
    return cfg;
  }

  // Actieve filters uit de URL — betrouwbaarder dan de filter-UI uitlezen.
  function activeMaterial() {
    var found = '';
    new URLSearchParams(window.location.search).forEach(function (value, key) {
      if (found) return;
      if (/houtsoort|materiaal|material|acryl/i.test(key)) found = value;
    });
    return found;
  }

  function activeType() {
    var params = new URLSearchParams(window.location.search);
    return params.get('filter.p.product_type') || '';
  }

  /* ── Kaart uitlezen ─────────────────────────────────────────────────────── */

  function describe(card) {
    var price = parseInt(card.getAttribute('data-wwc-price') || '0', 10);
    var variantMats = (card.getAttribute('data-wwc-variant-materials') || '')
      .split('|').map(function (s) { return s.trim(); }).filter(Boolean);
    // Zelfde volgorde als de materialen; lege plek = die variant heeft geen
    // eigen foto en houdt dus de productfoto.
    var variantImgs = (card.getAttribute('data-wwc-variant-images') || '').split('|');
    var variantIds = (card.getAttribute('data-wwc-variant-ids') || '').split('|');

    return {
      card: card,
      group: card.getAttribute('data-wwc-group') || '',
      type: card.getAttribute('data-wwc-type') || '',
      material: card.getAttribute('data-wwc-material') || '',
      variantMaterials: variantMats,
      variantImages: variantImgs,
      variantIds: variantIds,
      price: price,
      url: (card.querySelector('a.grid-product__link') || {}).href || '',
      priceHtml: (card.querySelector('.grid-product__price') || {}).innerHTML || '',
      priceText: ((card.querySelector('.grid-product__price') || {}).textContent || '').trim(),
      image: card.querySelector('.grid-product__image, .image-wrap img, img')
    };
  }

  function optionsFor(entries) {
    // Eén product met materiaal-varianten levert meerdere opties; losse
    // producten leveren er ieder één. Voor de klant is dat hetzelfde.
    if (entries.length === 1 && entries[0].variantMaterials.length > 1) {
      var e = entries[0];
      var kaartFoto = (e.image && (e.image.currentSrc || e.image.src)) || '';
      return e.variantMaterials.map(function (m, i) {
        var eigen = (e.variantImages[i] || '').trim();
        // De link krijgt de variant mee, anders opent het product op zijn
        // standaardkleur en is de keuze die je net maakte weg.
        var vid = (e.variantIds[i] || '').trim();
        var url = vid ? (e.url.split('?')[0] + '?variant=' + vid) : e.url;
        return { material: m, price: e.price, url: url, priceHtml: e.priceHtml, priceText: e.priceText,
                 image: eigen || kaartFoto, entry: e };
      });
    }
    return entries.map(function (x) {
      return {
        material: x.material,
        price: x.price,
        url: x.url,
        priceHtml: x.priceHtml,
        priceText: x.priceText,
        image: (x.image && (x.image.currentSrc || x.image.src)) || '',
        entry: x
      };
    });
  }

  /* ── Opruimen van een vorige ronde (load-more, filter-herlaad) ──────────── */

  function reset(scope) {
    scope.querySelectorAll('[data-wwc-merged]').forEach(function (c) { c.removeAttribute('data-wwc-merged'); });
    scope.querySelectorAll('.wwc-swatches, .wwc-group-flag, .wwc-price-from, .wwc-insert').forEach(function (n) { n.remove(); });
  }

  /* ── Renderen ───────────────────────────────────────────────────────────── */

  function renderGroup(entries, cfg, filterMat) {
    var options = sortOptions(optionsFor(entries), cfg.materialOrder || []);
    if (options.length < 2) return;

    var host = entries[0];                       // positie = collectievolgorde
    var card = host.card;
    var hero = pickHero(options, cfg.hero, filterMat);
    var low = minPrice(options);
    card.setAttribute('data-wwc-low', String(low));

    entries.slice(1).forEach(function (e) { e.card.setAttribute('data-wwc-merged', 'hidden'); });

    var meta = card.querySelector('.grid-product__meta');
    var link = card.querySelector('a.grid-product__link');
    var priceEl = card.querySelector('.grid-product__price');
    var imgEl = host.image;
    if (!meta) return;

    // De materiaal-pill wordt door wwc-collection.js pas ná ons toegevoegd, en
    // toont dan het materiaal van de eerste kaart — niet wat de klant ziet.
    // Daarom zoeken we 'm bij elke wissel opnieuw op en laten we 'm meelopen.
    function materialPill() {
      var wrap = meta.querySelector('.wwc-product-card-meta');
      if (!wrap) return null;
      // Niet op lastElementChild: de badge "8 materialen" wordt ná de pillen in
      // dezelfde rij gehangen, dus die was het laatste kind en dan gaf deze
      // functie null terug. Gericht de laatste materiaalpil pakken.
      var pillen = wrap.querySelectorAll('.wwc-product-pill:not(.wwc-product-pill--size):not(.wwc-product-pill--extra)');
      return pillen.length ? pillen[pillen.length - 1] : null;
    }

    // Motion faadt bij hover een tweede foto in. Die hoort bij het product dat
    // toevallig de kaart draagt — hover je een bolletje, dan zie je dus de
    // sfeerfoto van een ánder materiaal. Voor een groepskaart klopt dat niet.
    var secondary = card.querySelector('.grid-product__secondary-image');
    if (secondary) secondary.style.display = 'none';

    // DE BADGE GAAT VAN DE FOTO AF.
    //
    // Hij stond absoluut gepositioneerd op de afbeelding, wit op zwart-72%.
    // Daardoor hing zijn leesbaarheid af van welke foto er toevallig achter
    // zat: op een lichte skyline viel hij weg. In het tekstblok, tussen de
    // andere pills, is het contrast gegarandeerd - en hoort hij ook thuis,
    // want "8 materialen" is een eigenschap van het product en geen opdruk.
    //
    // Hier alleen maken; hangen gebeurt verderop, zodra `meta` bekend is.
    var flag = document.createElement('span');
    flag.className = 'wwc-group-flag';
    flag.textContent = options.length + ' ' + (cfg.labels && cfg.labels.materials || 'materialen');

    var row = document.createElement('div');
    row.className = 'wwc-swatches';
    row.setAttribute('role', 'group');
    row.setAttribute('aria-label', cfg.labels && cfg.labels.materials || 'materialen');

    var cheapest = options.reduce(function (a, b) { return b.price < a.price ? b : a; }, options[0]);

    /* Eén eerlijk prijsbereik in plaats van "vanaf X" met een grijze tweede regel.

       De kaart toonde de prijs van de standaarduitvoering met daaronder
       "andere materialen vanaf 49,00". Twee regels om één ding te zeggen, en
       het bovenste getal was niet de laagste maar ook niet de hoogste prijs -
       het maximum bleef verborgen. Vergelijken tussen kaarten kon daardoor niet,
       en dat is precies wat een prijsfilter had moeten oplossen. Dit lost het
       op zonder facet: je ziet in één regel waar het product begint en eindigt.

       De bedragen komen uit Shopify's eigen prijsregels, niet uit een eigen
       formattering: dan blijven valuta, scheidingsteken en taal vanzelf goed.
       Van het tweede bedrag halen we alleen het valutateken af, anders staat er
       "€ 49,00 - € 79,00" waar "€ 49,00 - 79,00" hoort. */
    function schoonBedrag(t) {
      return String(t || '')
        .replace(/^\s*(vanaf|from|ab|à\s*partir\s*de|a\s*partir\s*de)\s+/i, '')
        .trim();
    }

    /* De prijs op de kaart hoort bij het product OP de kaart.

       Ik heb hier vandaag twee keer iets anders geprobeerd en beide keren was
       het slechter dan wat er stond:

       - Een bereik ("99,00 - 129,00") is eerlijk, maar zet het hoogste bedrag
         vooraan en schrikt af voordat iemand heeft gezien wat hij krijgt.
       - Alleen "vanaf <laagste>" leest netjes, maar dan hoort de prijs bij een
         ANDER materiaal dan de foto laat zien. Je kijkt naar eiken en leest de
         prijs van zwart MDF.

       Wat er stond klopte dus al: het bedrag van de uitvoering die je ziet, en
       daaronder een tweede regel die alleen meldt DAT er iets goedkopers is.
       Het enige dat er werkelijk mis mee was, was het dubbele "vanaf" - en dat
       is los opgelost. Vandaar terug naar dit gedrag. */


    function show(opt) {
      if (imgEl && opt.image) {
        /* Foto omwisselen naar de gekozen uitvoering.
        
           Naast src en srcset moeten ook de lazy-load-sporen weg. Motion laadt
           gridfoto's uit `data-src` en markeert ze met de klasse `lazyload`; die
           bibliotheek draait opnieuw wanneer de browser een pagina uit het
           terugkeer-geheugen haalt. Bleef `data-src` staan met de oorspronkelijke
           foto erin, dan zette de bibliotheek bij terugkomst een leeg
           tussenplaatje terug en had je een gat waar het product hoorde te staan
           - precies wat je zag na "vorige" vanaf een variant.
        
           Door de foto als "al geladen" te markeren is er niets meer om opnieuw
           te doen. */
        imgEl.src = opt.image;
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('data-srcset');
        imgEl.removeAttribute('data-widths');
        imgEl.setAttribute('data-src', opt.image);
        imgEl.classList.remove('lazyload', 'lazypreload');
        imgEl.classList.add('lazyloaded');
        imgEl.style.opacity = '1';
      }
      if (link && opt.url) link.href = opt.url;
      if (priceEl) {
        priceEl.innerHTML = opt.priceHtml || priceEl.innerHTML;

        // Alleen melden dát er iets goedkopers is; niet twee bedragen naast
        // elkaar zetten, want dat leest als tegenspraak.
        if (opt.price > low && cheapest.priceText) {
          var from = document.createElement('span');
          from.className = 'wwc-price-from';
          from.textContent = ((cfg.labels && cfg.labels.from) || 'andere materialen vanaf')
                             + ' ' + schoonBedrag(cheapest.priceText);
          priceEl.appendChild(from);
        }
      }

      var pill = materialPill();
      if (pill && opt.material) {
        pill.textContent = vertaalMateriaal(opt.material, cfg);
        pill.className = 'wwc-product-pill wwc-product-pill--' + materialClass(opt.material);
      }
    }

    var chosen = hero;
    var prevAcryl = null;

    options.forEach(function (opt) {
      var isAcryl = (cfg.acrylMaterials || []).indexOf(opt.material) > -1;
      if (prevAcryl !== null && isAcryl !== prevAcryl) {
        var sep = document.createElement('span');
        sep.className = 'wwc-swatches__sep';
        row.appendChild(sep);
      }
      prevAcryl = isAcryl;

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wwc-swatch wwc-swatch--' + materialClass(opt.material);
      b.setAttribute('aria-label', vertaalMateriaal(opt.material, cfg));
      // Geen `title` meer: die gaf naast ons eigen label ook nog de trage
      // browser-tooltip, dus twee keer dezelfde naam met een seconde ertussen.
      // aria-label dekt de toegankelijkheid en voedt tegelijk het CSS-label.
      b.setAttribute('aria-pressed', opt === chosen ? 'true' : 'false');
      if (filterMat && opt.material !== filterMat) b.classList.add('is-dim');

      b.addEventListener('mouseenter', function () { show(opt); });
      b.addEventListener('mouseleave', function () { show(chosen); });
      b.addEventListener('click', function (e) {
        /* De klik mag NIET doorlopen naar de productlink.

           Gemeten: alle veertien kaarten met bolletjes zetten die knopjes binnen
           de <a> van de productkaart. Een <button> in een <a> is ongeldige HTML
           en browsers gaan er verschillend mee om: zonder preventDefault volgt
           de browser gewoon de link. Je tikte dus op een kleur en belandde op de
           productpagina - meestal nog met de variant van vóór je klik, want de
           href was op dat moment nog niet bijgewerkt. Precies het gedrag dat
           gemeld werd als "de kleurknoppen gaan naar het hoofdproduct".

           stopPropagation erbij omdat het thema zelf ook op de kaart luistert
           (quick shop); anders opent dat paneel bij het kiezen van een kleur. */
        e.preventDefault();
        e.stopPropagation();

        chosen = opt;
        row.querySelectorAll('.wwc-swatch').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        show(opt);
      });

      row.appendChild(b);
    });

    // Een kaart is ~168px breed; zes bolletjes plus streepje vragen 183px, en
    // Amsterdam heeft er acht. Verder verkleinen lost dat niet op — daarom
    // tonen we er vijf en vouwen we de rest op achter een +N die uitklapt.
    // Hoeveel bolletjes passen, hangt af van de kolombreedte — en die verschilt
    // per scherm én per instelling 'producten per rij'. Daarom rekenen we het
    // uit in plaats van een vast getal te kiezen, en herhalen we dat bij resize.
    var expanded = false;
    var more = null;

    function fit() {
      var W = row.clientWidth;
      if (!W) return;

      var first = row.querySelector('.wwc-swatch');
      if (!first) return;

      var cs = getComputedStyle(row);
      var G = parseFloat(cs.columnGap || cs.gap) || 5;
      var S = first.getBoundingClientRect().width || 26;
      var sepW = row.querySelector('.wwc-swatches__sep') ? 3 + G : 0;
      var per = function (extra) { return Math.floor((W + G - sepW - extra) / (S + G)); };

      var passen = per(0);
      var n = options.length;

      if (expanded || n <= passen) { apply(n); return; }

      // Er moet een +N bij, en die kost zelf ook ruimte.
      // Hoogstens vier bolletjes, ook als er breedte voor meer is. De rij paste
      // zich tot nu toe alleen aan de beschikbare ruimte aan, waardoor de ene
      // kaart er vijf toonde en de andere acht — en dat is precies de onrust
      // die we uit de kaart wilden halen. Vier plus een restgetal is overal
      // hetzelfde en laat nog steeds zien dát er meer is.
      apply(Math.min(4, Math.max(2, per(34 + G))));
    }

    function apply(limit) {
      var shown = 0;
      Array.prototype.forEach.call(row.children, function (el) {
        if (el === more) return;
        if (el.classList.contains('wwc-swatch')) {
          var hide = shown >= limit;
          el.hidden = hide;
          if (!hide) shown += 1;
        } else {
          el.hidden = shown >= limit;      // scheidingsstreepje voorbij de knip
        }
      });

      var rest = options.length - limit;
      if (rest > 0 && !expanded) {
        if (!more) {
          more = document.createElement('button');
          more.type = 'button';
          more.className = 'wwc-swatch-more';
          more.setAttribute('aria-label', options.length + ' ' + (cfg.labels && cfg.labels.materials || 'materialen'));
          more.addEventListener('click', function (e) {
            e.preventDefault();
            expanded = true;
            more.remove();
            more = null;
            apply(options.length);
          });
          row.appendChild(more);
        }
        more.textContent = '+' + rest;
        more.hidden = false;
      } else if (more) {
        more.remove();
        more = null;
      }
    }

    var anchor = meta.querySelector('.wwc-product-card-meta') || meta.querySelector('.grid-product__title');
    if (anchor) anchor.insertAdjacentElement('afterend', row); else meta.appendChild(row);

    // Badge bij de pills zetten. Staat die rij er niet, dan boven de bolletjes.
    var pillrij = meta.querySelector('.wwc-product-card-meta');
    if (pillrij) pillrij.appendChild(flag); else row.parentNode.insertBefore(flag, row);

    // OPNIEUW LATEN PASSEN NA DE BADGE.
    //
    // fit() rekent met row.clientWidth. De badge staat sinds vandaag in dezelfde
    // kolom als de bolletjes, dus zijn komst verandert de opmaak ná die meting.
    // Zonder deze herberekening denkt fit() dat alle acht bolletjes passen en
    // verdwijnt de +N-knop: gemeten stonden ze over drie regels en groeide de
    // kaart van 411 naar 442px.
    requestAnimationFrame(fit);

    show(hero);
    // Eén keer meteen, en nog eens zodra de browser klaar is met opmaken: bij
    // de eerste aanroep staat de rij er wel, maar zijn de breedtes nog niet
    // definitief — dan telt hij er te veel.
    fit();
    requestAnimationFrame(fit);
    card.__wwcSync = function () { show(chosen); };
    card.__wwcFit = fit;
    card.__wwcMaterials = options.map(function (o) { return o.material; });

    // Aansturing vanaf de globale houtsoort-kiezer. Heeft dit product het
    // gevraagde materiaal niet, dan gebeurt er niets: de kaart houdt z'n eigen
    // materiaal. Verbergen of dimmen zou 'm als filter laten voelen.
    card.__wwcPick = function (naam) {
      var hit = null;
      options.forEach(function (o) { if (!hit && o.material === naam) hit = o; });
      if (!hit) return false;
      chosen = hit;
      row.querySelectorAll('.wwc-swatch').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      var idx = options.indexOf(hit);
      var knoppen = row.querySelectorAll('.wwc-swatch');
      if (knoppen[idx]) knoppen[idx].setAttribute('aria-pressed', 'true');
      show(hit);
      return true;
    };

    // Pijltoetsen door de bolletjes — kost niets en helpt toetsenbordgebruikers.
    row.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      var knoppen = Array.prototype.filter.call(row.querySelectorAll('.wwc-swatch'), function (b) { return !b.hidden; });
      var hier = knoppen.indexOf(document.activeElement);
      if (hier < 0) return;
      e.preventDefault();
      var volgende = knoppen[hier + (e.key === 'ArrowRight' ? 1 : -1)];
      if (volgende) { volgende.focus(); volgende.click(); }
    });
  }

  /* ── Globale houtsoort-kiezer ───────────────────────────────────────────── */

  var BEWAARSLEUTEL = 'wwc:materiaal';

  function bewaard() {
    try { return sessionStorage.getItem(BEWAARSLEUTEL) || ''; } catch (e) { return ''; }
  }
  function bewaar(naam) {
    try { sessionStorage.setItem(BEWAARSLEUTEL, naam); } catch (e) {}
  }

  function kiesOveral(naam) {
    document.querySelectorAll('.grid-product[data-wwc-group], .grid-product[data-wwc-variant-materials]').forEach(function (c) {
      if (typeof c.__wwcPick === 'function') c.__wwcPick(naam);
    });
  }

  function bouwHoutkiezer(cfg, filterMat) {
    var host = document.querySelector('[data-wwc-wood-picker]');
    if (!host) return;

    // Alleen materialen die op déze pagina echt voorkomen.
    var aanwezig = {};
    document.querySelectorAll('.grid-product').forEach(function (c) {
      if (Array.isArray(c.__wwcMaterials)) c.__wwcMaterials.forEach(function (m) { if (m) aanwezig[m] = 1; });
    });

    var lijst = Object.keys(aanwezig);
    if (lijst.length < 2) { host.hidden = true; return; }
    lijst = lijst.sort(function (a, b) {
      return orderIndex(a, cfg.materialOrder || []) - orderIndex(b, cfg.materialOrder || []);
    });

    host.innerHTML = '';
    host.hidden = false;

    var lbl = document.createElement('span');
    lbl.className = 'wwc-wood-picker__label';
    lbl.textContent = host.getAttribute('data-label') || 'Toon alles in';
    host.appendChild(lbl);

    // Een materiaal in de URL (filter) wint van wat we onthouden hebben.
    var actief = filterMat || bewaard();

    // Acht keuzes vóór de bezoeker een productsoort koos is te veel — en de
    // laatste vier zijn geen hout maar acrylaat. Die zitten achter 'meer'.
    var TOON = Math.max(2, parseInt(cfg.woodPickerVisible, 10) || 4);

    // Op smalle schermen passen er simpelweg minder. Gemeten op 375px: de rij is
    // 321px breed, het label "Toon alles in" pakt daarvan 77px, en een chip is
    // 76 tot 113px ("Palissander"). Er passen er dus TWEE plus de meer-knop.
    // Met de ingestelde vier werd niet alleen de derde en vierde chip halverwege
    // afgesneden, maar ook de "+4"-knop zelf - de bezoeker zag een afgekapte
    // rij zonder te kunnen zien dat er meer was.
    //
    // Hier aanpassen en niet in CSS: de teller wordt hieronder uit TOON
    // afgeleid, dus chips wegverbergen met CSS zou "+4" laten staan terwijl er
    // zes verborgen zijn. Een tellertje dat liegt is erger dan een afgesneden chip.
    if (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) {
      TOON = Math.min(TOON, 2);
    }
    var verborgen = 0;

    lijst.forEach(function (m, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wwc-wood-chip';
      var extra = i >= TOON && m !== actief;
      if (extra) { b.setAttribute('data-extra', '1'); verborgen += 1; }
      b.setAttribute('aria-pressed', m === actief ? 'true' : 'false');
      b.innerHTML = '<i class="wwc-wood-chip__dot wwc-swatch--' + materialClass(m) + '"></i>' + m;
      b.addEventListener('click', function () {
        var aan = b.getAttribute('aria-pressed') === 'true';
        host.querySelectorAll('.wwc-wood-chip').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        if (aan) { bewaar(''); return; }          // nogmaals tikken = keuze los
        b.setAttribute('aria-pressed', 'true');
        bewaar(m);
        kiesOveral(m);
      });
      host.appendChild(b);
    });

    if (verborgen > 0) {
      host.classList.add('is-collapsed');
      var meer = document.createElement('button');
      meer.type = 'button';
      meer.className = 'wwc-wood-chip wwc-wood-chip--meer';
      meer.textContent = '+' + verborgen;
      meer.setAttribute('aria-label', 'Meer materialen tonen');
      meer.addEventListener('click', function () {
        host.classList.remove('is-collapsed');
        meer.remove();
      });
      host.appendChild(meer);
    }

    if (actief) kiesOveral(actief);
  }

  /* ── Plakkende, inklappende kop ─────────────────────────────────────────── */

  function volgScroll() {
    var kop = document.querySelector('[data-wwc-sticky-head]');
    if (!kop || kop.__wwcBalkGebouwd) return;
    kop.__wwcBalkGebouwd = true;

    // De kop zélf laten plakken en dan laten krimpen liet de pagina eronder
    // omhoog springen. Daarom een losse balk buiten de pagina-stroom, die
    // verschijnt zodra de kop uit beeld is. Alleen wat je bladerend nodig hebt.
    var balk = document.createElement('div');
    balk.className = 'wwc-slim-bar';
    balk.setAttribute('role', 'navigation');
    balk.setAttribute('aria-label', 'Producttypes');

    // FILTER EERST, LINKS. Model van Bol: de filterknop staat vooraan en is
    // gevuld, de rest zijn omlijnde chips. Stond hier rechts als kaal
    // hamburger-teken zonder woord - een icoon dat je moet raden.
    var filterBron = kop.querySelector('[data-wwc-open-filters]');
    if (filterBron) {
      var f = document.createElement('button');
      f.type = 'button';
      f.className = 'wwc-slim-bar__filter';
      f.innerHTML = '\u2630 Filter';
      f.setAttribute('aria-label', 'Filter producten');
      f.addEventListener('click', function () { filterBron.click(); });
      balk.appendChild(f);
    }

    var rij = document.createElement('div');
    rij.className = 'wwc-slim-bar__types';
    balk.appendChild(rij);

    var origineel = kop.querySelectorAll('.wwc-visual-type-card');
    if (!origineel.length) return;

    /* Drie knoppen in plaats van een rij chips.

       Hier stond eerst elke productsoort als eigen chip. Op een telefoon paste
       daar niets van: acht tot zestien chips op 390px worden een tweede
       horizontale veeg bovenop de rij die je net verlaten hebt, en de balk is
       er juist om ruimte te besparen. Nu drie ingangen die alle drie hetzelfde
       paneel openen, met in het label wat er nú aanstaat - zo is de balk niet
       alleen een snelkoppeling maar vertelt hij ook waar je staat. */
    function huidigeSoort() {
      var actief = null;
      origineel.forEach(function (b) {
        if (!b.classList.contains('is-active')) return;
        if (!b.getAttribute('data-wwc-product-filter')) return;   // 'alles' telt niet
        actief = (b.querySelector('span:not(.wwc-visual-type-card__image)') || {}).textContent || '';
      });
      return actief && actief.trim();
    }

    function huidigMateriaal() {
      var chip = document.querySelector('.wwc-wood-chip.is-active, .wwc-wood-chip[aria-pressed="true"]');
      return chip ? (chip.textContent || '').trim() : null;
    }

    /* Eigen keuzelijstje in plaats van het volledige filterpaneel.

       "Materiaal" opende eerst de hele filterlade: dat is drie keer zoveel
       scherm voor één keuze, en je moest er zelf de goede groep in zoeken.
       Een kort lijstje onder de knop is wat de knop belooft. De keuzes komen
       uit de elementen die al op de pagina staan en de klik wordt daarheen
       doorgegeven, zodat er maar één plek is waar de filterlogica leeft. */
    var openPop = null;

    function sluitPop() {
      if (!openPop) return;
      openPop.pop.remove();
      openPop.chip.setAttribute('aria-expanded', 'false');
      openPop = null;
    }

    document.addEventListener('click', function (e) {
      if (!openPop) return;
      if (openPop.pop.contains(e.target) || openPop.chip.contains(e.target)) return;
      sluitPop();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sluitPop(); });

    function toonPop(chip, items) {
      if (openPop && openPop.chip === chip) { sluitPop(); return; }
      sluitPop();
      if (!items.length) return;

      var pop = document.createElement('div');
      pop.className = 'wwc-slim-pop';
      pop.setAttribute('role', 'listbox');

      items.forEach(function (it) {
        if (it.kop) {
          var k = document.createElement('div');
          k.className = 'wwc-slim-pop__kop';
          k.textContent = it.naam;
          pop.appendChild(k);
          return;
        }
        var r = document.createElement('button');
        r.type = 'button';
        r.className = 'wwc-slim-pop__rij' + (it.actief ? ' is-actief' : '');
        r.setAttribute('role', 'option');
        r.setAttribute('aria-selected', it.actief ? 'true' : 'false');
        if (it.kleur) {
          var bol = document.createElement('i');
          bol.className = 'wwc-slim-pop__bol';
          bol.style.background = it.kleur;
          r.appendChild(bol);
        }
        var t = document.createElement('span');
        t.textContent = it.naam;
        r.appendChild(t);
        if (it.aantal) {
          var n = document.createElement('em');
          n.className = 'wwc-slim-pop__aantal';
          n.textContent = it.aantal;
          r.appendChild(n);
        }
        r.addEventListener('click', function () { sluitPop(); it.kies(); });
        pop.appendChild(r);
      });

      /* Aan de balk hangen, niet aan de knoppenrij.
         Die rij heeft overflow:auto (hij mag zelf schuiven als er veel in
         staat), en daarmee knipte hij het lijstje af: gemeten stond er een
         paneel van 168x395 in een vak van 55px hoog, dus je zag een streepje
         en verder niets. Vandaar dat de knoppen "niets leken te doen".
         De balk zelf staat op overflow:visible. */
      balk.appendChild(pop);
      var bRect = balk.getBoundingClientRect();
      var cRect = chip.getBoundingClientRect();
      pop.style.left = Math.max(6, cRect.left - bRect.left) + 'px';
      chip.setAttribute('aria-expanded', 'true');
      openPop = { pop: pop, chip: chip };
    }

    function collectieItems() {
      var uit = [];
      origineel.forEach(function (b) {
        var naam = ((b.querySelector('span:not(.wwc-visual-type-card__image)') || {}).textContent || '').trim();
        if (!naam) return;
        uit.push({ naam: naam, actief: b.classList.contains('is-active'), kies: function () {
          try { sessionStorage.setItem('wwc:naar-boven', '1'); } catch (e) {}
          b.click();
        } });
      });
      return uit;
    }

    /* Materialen uit de échte filterwaarden van Shopify, niet uit onze eigen
       houtchips.

       Die chips tonen alleen de houtsoorten die de groepsmodule kent, zonder
       aantallen, en ze zetten een ánder filter dan het grote filterpaneel. Koos
       je hier iets en daarna daar, dan vochten die twee met elkaar. Door de
       lijst uit dezelfde bron te halen als het paneel - de filterindex die de
       sectie al meestuurt - staat er één waarheid, staan acryl en hout er
       allebei in, en klopt het aantal per materiaal. */
    function filterIndex() {
      var el = document.querySelector('[data-wwc-filter-index]');
      if (!el) return [];
      try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
    }

    function kleurVoor(naam) {
      var sleutel = String(naam).toLowerCase();
      var chip = null;
      document.querySelectorAll('.wwc-wood-chip').forEach(function (c) {
        if (chip) return;
        if ((c.textContent || '').trim().toLowerCase() === sleutel) chip = c;
      });
      if (!chip) return '';
      var bol = chip.querySelector('i, .wwc-wood-chip__dot, span[style]');
      return bol ? getComputedStyle(bol).backgroundColor : '';
    }

    function materiaalItems() {
      var index = filterIndex();
      var actieveUrl = decodeURIComponent(window.location.search);

      /* De soorten, niet de hoofdindeling.

         Shopify heeft hier drie groepen: "Materiaal" met alleen Hout en Acryl,
         en daarnaast "Houtsoort" (Eiken, Noten, Palissander, Bamboe, Zwart) en
         "Acrylsoort" (Wit Glanzend, Zwart Glanzend, Goud Metallic). De grove
         indeling zegt de bezoeker weinig - iedereen die hier filtert wil een
         hóutsoort kiezen, niet de categorie hout. Dus tonen we beide
         soortgroepen onder elkaar, met een kopregel ertussen zodat duidelijk
         blijft wat hout is en wat acryl. */
      var soortGroepen = [];
      index.forEach(function (e) {
        var g = String(e.filter || '');
        if (!/soort|type de|art$/i.test(g)) return;
        if (/collectie|collection/i.test(g)) return;
        if (soortGroepen.indexOf(g) < 0) soortGroepen.push(g);
      });
      if (!soortGroepen.length) {
        index.forEach(function (e) {
          var g = String(e.filter || '');
          if (/materia|matéri/i.test(g) && soortGroepen.indexOf(g) < 0) soortGroepen.push(g);
        });
      }
      if (!soortGroepen.length) return [];

      var uit = [];
      soortGroepen.forEach(function (g) {
        var waarden = index.filter(function (e) { return e.filter === g; });
        if (!waarden.length) return;
        if (soortGroepen.length > 1) uit.push({ naam: g, kop: true });
        waarden.forEach(function (e) {
          var naam = String(e.label || '').trim();
          uit.push({
            naam: naam,
            aantal: e.count,
            kleur: kleurVoor(naam),
            actief: actieveUrl.indexOf(naam) > -1,
            kies: function () { gaNaar(e.url); }
          });
        });
      });
      return uit;
    }

    /* Na een keuze uit de balk hoort de pagina bovenaan te beginnen.
       De balk staat halverwege de pagina; laadt hij opnieuw op diezelfde hoogte,
       dan kijk je naar het midden van een raster dat inmiddels iets heel anders
       toont. De vlag overleeft de navigatie, het herstel gebeurt bij het opbouwen. */
    function gaNaar(url) {
      try { sessionStorage.setItem('wwc:naar-boven', '1'); } catch (e) {}
      window.location.href = url;
    }

    function maakChip(standaard, waarde, items) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'wwc-slim-chip wwc-slim-chip--paneel' + (waarde ? ' is-gekozen' : '');
      c.innerHTML = (waarde || standaard) + ' <span aria-hidden="true">\u25BE</span>';
      c.setAttribute('aria-label', standaard + (waarde ? ': ' + waarde : ''));
      c.setAttribute('aria-expanded', 'false');
      c.setAttribute('aria-haspopup', 'listbox');
      c.addEventListener('click', function (e) { e.stopPropagation(); toonPop(c, items()); });
      rij.appendChild(c);
      return c;
    }

    maakChip('Collectie', huidigeSoort(), collectieItems);
    maakChip('Materiaal', huidigMateriaal(), materiaalItems);

    // Weg terug, alleen zichtbaar als er iets aanstaat.
    if (window.location.search.indexOf('filter.') > -1) {
      var wis = document.createElement('a');
      wis.className = 'wwc-slim-wis';
      wis.href = window.location.pathname;
      wis.setAttribute('aria-label', 'Wis filters');
      wis.title = 'Wis filters';
      wis.innerHTML = '<span aria-hidden="true">\u00d7</span>';
      wis.addEventListener('click', function () {
        try { sessionStorage.setItem('wwc:naar-boven', '1'); } catch (e) {}
      });
      rij.appendChild(wis);
    }

    document.body.appendChild(balk);

    // Actieve chip meelopen als er gefilterd wordt.
    kop.addEventListener('click', function (e) {
      if (!e.target.closest('.wwc-visual-type-card')) return;
      setTimeout(function () {
        kop.querySelectorAll('.wwc-visual-type-card').forEach(function (bron, i) {
          var chip = rij.children[i];
          if (chip) chip.setAttribute('aria-pressed', bron.classList.contains('is-active') ? 'true' : 'false');
        });
      }, 60);
    });

    // Waar houdt de sitekop op? Die is in dit thema soms plakkend en soms niet,
    // en de hoogte verschilt per breedte. Uitrekenen dus, in plaats van een
    // vast getal kiezen — anders zweeft de balk eronder of eroverheen.
    function kopOnderkant() {
      var laag = 0;
      document.querySelectorAll('.site-header, #SiteHeader, .header-wrapper, [data-header-wrapper], .header-sticky-wrapper, .announcement-bar').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
        var r = el.getBoundingClientRect();
        if (r.top <= 2 && r.bottom > laag) laag = r.bottom;
      });
      return Math.max(0, Math.round(laag));
    }

    var bezig = false;
    var vorigeTop = -1;
    var vorigeY = window.pageYOffset || 0;
    var omhoog = false;
    function meet() {
      bezig = false;
      // De balk hangt fixed op top 0 met z-index 11 en schuift weg met een
      // transition van 0,18s; het hoofdmenu staat gewoon in de pagina zonder
      // z-index. Met de oude drempel (bottom <= 0) begon het wegschuiven pas
      // toen het menu alweer in beeld kwam, en lag de balk er dus even overheen.
      // Door de drempel met de eigen hoogte te verschuiven is de balk weg tegen
      // de tijd dat het menu er is. Verzachting, geen garantie: wie heel snel
      // scrollt kan hem nog net zien.
      var balkHoogte = balk.offsetHeight || 55;
      var weg = kop.getBoundingClientRect().bottom <= -balkHoogte;
      var top = kopOnderkant();
      if (top !== vorigeTop) {
        balk.style.top = top + 'px';
        vorigeTop = top;
      }
      // SMART STICKY: alleen tonen bij OMHOOG scrollen.
      //
      // De balk stond altijd aan zodra je de header voorbij was, en zat daarmee
      // in de weg tijdens het bladeren - precies wanneer de bezoeker de meeste
      // ruimte wil. Omhoog scrollen is het signaal "ik ben klaar hier, ik zoek
      // iets": dan is een filterbalk juist welkom.
      //
      // Zelfde patroon als Bol en Amazon. De drempel van 6px voorkomt dat de
      // balk knippert bij de kleine correcties die een vinger nu eenmaal maakt.
      var y = window.pageYOffset || 0;
      if (Math.abs(y - vorigeY) > 6) {
        omhoog = y < vorigeY;
        vorigeY = y;
      }
      balk.classList.toggle('is-visible', weg && omhoog);
    }
    function opScroll() {
      if (bezig) return;
      bezig = true;
      requestAnimationFrame(meet);
    }
    window.addEventListener('scroll', opScroll, { passive: true });
    window.addEventListener('resize', opScroll, { passive: true });
    meet();
  }

  /* ── Insert-tegels ──────────────────────────────────────────────────────── */

  function renderProductInserts(grid, filterMat, typeSel) {
    var ingevoegd = false;
    var gebruiktePosities = [];
    // Een ECHT product op een gekozen plek. Anders dan de tegels hierboven komt
    // de opmaak van het thema zelf (product-grid-item), zodat de kaart niet
    // afwijkt van zijn buren: echte foto, echte prijs, zelfde hoogte.
    //
    // Waarom uit een <template> en niet gewoon in de grid: een kaart die al in
    // de grid staat wordt meegeteld en mogelijk samengevouwen, en zou tot de JS
    // hem verplaatst op de verkeerde plek staan - zichtbaar verspringen dus.
    Array.prototype.forEach.call(
      document.querySelectorAll('template[data-wwc-insert-product]'), function (tpl) {

      // Altijd eerst opruimen: boot() draait opnieuw bij filteren en sorteren,
      // en zonder dit stapelen de kopieen zich op.
      var oud = grid.querySelector('[data-wwc-insert="' + tpl.id + '"]');
      if (oud) oud.parentNode.removeChild(oud);

      if (filterMat) return;                                    // klant verfijnt

      // Stond het producttype van de tegel leeg, dan viel de tweede test hier
      // weg en verscheen de tegel onder ELK filter - ook bij "Serveerplank",
      // waar een stadskaart niets te zoeken heeft. Nu bepaalt de winkel dat:
      // standaard verdwijnt de tegel zodra er een productsoort gekozen is.
      var alleenOngefilterd = tpl.getAttribute('data-only-unfiltered') !== '0';
      if (alleenOngefilterd && typeSel) return;

      var type = tpl.getAttribute('data-type') || '';
      if (typeSel && type && typeSel !== type) return;          // ander producttype

      var bron = tpl.content && tpl.content.firstElementChild;
      if (!bron) return;

      /* Nooit invoegen wat er al staat.

         Op /collections/jouw-plek stond het product twee keer: één keer als
         gewone kaart uit de collectie en één keer als ingevoegde tegel, omdat
         die tegel juist naar dát product wijst. De tegel is bedoeld om een
         product te tonen dat NIET in deze collectie zit; zit het er wel in, dan
         is de tegel per definitie een dubbeling.

         Hier gecontroleerd en niet alleen in het template opgelost, want dit
         gaat zich herhalen: zodra iemand het product aan een collectie toevoegt
         waar ook een tegel staat, is het weer raak. */
      var eigenHandle = bron.getAttribute('data-product-handle');
      if (eigenHandle) {
        var alAanwezig = grid.querySelector(
          '.grid-product[data-product-handle="' + eigenHandle + '"]:not([data-wwc-insert])');
        if (alAanwezig && alAanwezig.getAttribute('data-wwc-merged') !== 'hidden') return;
      }

      var kaart = bron.cloneNode(true);
      kaart.setAttribute('data-wwc-insert', tpl.id);

      // Uitlichten. De niveaus zitten in de stylesheet; hier alleen de klasse.
      var licht = tpl.getAttribute('data-highlight') || 'zacht';
      if (licht !== 'geen') kaart.classList.add('wwc-insert-kaart', 'wwc-insert-kaart--' + licht);

      /* De stad meegeven aan de productpagina.
      
         De stadskaart is een leeg product: je komt er binnen en moet zelf nog
         bedenken welke plaats je wilt. Terwijl we op dít moment precies weten
         waar de bezoeker naar keek - hij staat op de collectiepagina van die
         stad. Die kennis weggooien bij de klik en het hem opnieuw laten
         intypen is de duurste stap in de trechter gratis weggeven.
      
         Als queryparameter en niet in de opslag van de browser: een link met
         ?plaats=Utrecht kun je delen, terugsturen en meten, en hij overleeft
         een nieuw tabblad. De generator leest hem uit; leest hij hem niet, dan
         is er niets stuk - de bezoeker ziet gewoon het lege formulier zoals nu.
      
         Alleen op de eigen link van de tegel, niet op de hele grid: de andere
         producten zijn geen configurator en hebben er niets aan. */
      var plaats = tpl.getAttribute('data-plaats');
      if (plaats) {
        Array.prototype.forEach.call(kaart.querySelectorAll('a[href]'), function (a) {
          var href = a.getAttribute('href') || '';
          if (!href || href.charAt(0) === '#') return;
          if (href.indexOf('plaats=') > -1) return;
          a.setAttribute('href', href + (href.indexOf('?') > -1 ? '&' : '?') + 'plaats=' + encodeURIComponent(plaats));
        });
      }

      /* De USP-regel hoort ONDER de foto, bij de tekst.

         Hij stond als eerste kind van de kaart, dus boven alles, over de volle
         breedte en met een gevulde accentkleur. Gemeten: 230px breed, wit op
         bruin, direct tegen de rand van het raster. Dat leest als een
         reclamebalk die op de kaart geplakt is in plaats van als informatie
         die erbij hoort. In het tekstblok staat hij op dezelfde plek waar bij
         elk ander product de feitenregel staat.

         Ook losgekoppeld van het uitlichtniveau: de tekst zei iets zinnigs
         ("Kaart van Genemuiden, of elke andere plek") maar verdween zodra je
         de kaart subtieler wilde. Twee verschillende keuzes horen niet aan één
         schakelaar te hangen. `insert_highlight` gaat nu alleen nog over het
         vlak, de labeltekst over de tekst. */
      var label = tpl.getAttribute('data-label');
      if (label) {
        var l = document.createElement('span');
        l.className = 'wwc-insert-label';
        l.textContent = label;
        var meta = kaart.querySelector('.grid-product__meta') ||
                   kaart.querySelector('.grid-product__content');
        var titel = meta && meta.querySelector('.grid-product__title');
        if (titel) meta.insertBefore(l, titel.nextSibling);
        else if (meta) meta.insertBefore(l, meta.firstChild);
        else kaart.insertBefore(l, kaart.firstChild);
      }

      var zichtbaar = Array.prototype.filter.call(grid.children, function (c) {
        return c.getAttribute('data-wwc-merged') !== 'hidden';
      });
      var pos = parseInt(tpl.getAttribute('data-pos'), 10) || 1;

      /* Nooit twee tegels dicht op elkaar.
      
         Met meerdere tegels kan de winkel per ongeluk posities 6 en 8 kiezen, en
         dan staan er twee aanbiedingen met één product ertussen - dat leest als
         een advertentiepagina en maakt de echte producten goedkoper. Vier
         posities afstand is de ondergrens; staat een tegel te dicht op de
         vorige, dan schuift hij naar beneden in plaats van te verdwijnen. De
         winkel houdt zo altijd zijn tegel, alleen niet per se op de pixel. */
      /* Heeft de klant zelf gesorteerd, dan hoort onze tegel niet voor te
         dringen. Op positie 5 stond hij tussen producten van 24,95 en 24,95 in
         met een prijs van 31,95 - in een lijst die je juist op prijs hebt
         gezet. Achteraan blijft hij beschikbaar zonder de volgorde te breken. */
      if (klantSortering()) pos = zichtbaar.length + 1;

      gebruiktePosities.forEach(function (eerder) {
        if (Math.abs(pos - eerder) < 4) pos = eerder + 4;
      });
      gebruiktePosities.push(pos);

      var at = Math.max(0, Math.min(pos - 1, zichtbaar.length));
      grid.insertBefore(kaart, zichtbaar[at] || null);
      ingevoegd = true;
    });

    // HET THEMA MOET DE NIEUWE KAART NOG LEREN KENNEN.
    //
    // theme.initQuickShop() hangt een mouseover- en focusin-luisteraar aan elke
    // .grid-product die op dat moment bestaat. Onze kaart komt daarna binnen en
    // krijgt die luisteraar dus niet - quick view doet het dan niet, terwijl de
    // knop er wel staat. Zelfde reden als waarom wwc-collection.js na 'laad
    // meer' reInitTheme() aanroept.
    //
    // Alleen aanroepen als er echt iets is ingevoegd: de functie loopt over alle
    // kaarten en zet er opnieuw luisteraars op, dus onnodig aanroepen stapelt.
    if (ingevoegd && window.theme && typeof theme.reinitProductGridItem === 'function') {
      try { theme.reinitProductGridItem(grid); } catch (e) {}
    }
  }

  function renderInserts(grid, cfg, filterMat, typeSel) {
    (cfg.inserts || []).forEach(function (ins) {
      if (filterMat) return;                                   // klant verfijnt
      if (typeSel && ins.type && typeSel !== ins.type) return;  // ander producttype

      var a = document.createElement('a');
      a.className = 'grid__item grid-product wwc-insert';
      a.href = ins.url || '#';
      a.innerHTML =
        '<span class="wwc-insert__img">' +
          (ins.image ? '<img alt="" loading="lazy" src="' + ins.image + '">' : (ins.emoji || '✏️')) +
        '</span>' +
        '<span class="wwc-insert__body">' +
          (ins.badge ? '<span class="wwc-insert__badge">' + ins.badge + '</span>' : '') +
          '<span class="wwc-insert__title">' + (ins.title || '') + '</span>' +
          (ins.text ? '<span class="wwc-insert__text">' + ins.text + '</span>' : '') +
          '<span class="wwc-insert__cta">' + (ins.cta || '') + '</span>' +
        '</span>';

      var visible = Array.prototype.filter.call(grid.children, function (c) {
        return c.getAttribute('data-wwc-merged') !== 'hidden';
      });
      var at = Math.max(0, Math.min((ins.position || 1) - 1, visible.length));
      grid.insertBefore(a, visible[at] || null);
    });
  }

  /* ── Aansturing ─────────────────────────────────────────────────────────── */

  function run(section) {
    var cfg = readConfig(section);
    if (!cfg || !cfg.enabled) return;

    var grid = section.querySelector('.product-grid-container') ||
               section.querySelector('[data-wwc-grid-shell]');
    if (!grid) return;

    reset(grid);

    var filterMat = activeMaterial();
    var typeSel = activeType();

    var rijTypes = (cfg.rowTypes || []).map(function (t) { return String(t).trim(); }).filter(Boolean);

    /* Bundelen in twee slagen.
    
       Slag 1 zet alles op serie (de _alt_-tag). Slag 2 splitst een serie alleen
       als daar écht twee productsoorten in zitten die allebei als kaartje in de
       rij staan.
    
       Waarom niet in één keer op serie + type: de _alt_-tags zijn niet overal
       even zorgvuldig gezet, en dat komt in twee smaken.
       - De wandskyline en de shape-skyline van Utrecht delen `_alt_skyline-utrecht`
         terwijl hun type verschilt ("Skyline" en "Skyline Shape"). Allebei staan
         ze in de rij met eigen aantallen, dus die kaart moet uit elkaar - anders
         kies je een houtsoort en krijg je een andere vorm.
       - De Standing Skyline van Utrecht is één serie waarvan vier producten
         "Skyline" heten en vier "Standing Skyline". Dat laatste type staat niet
         in de rij, er valt dus niets op te klikken, en splitsen zou de serie
         zonder reden in vier hout en vier acryl hakken.
    
       De test "staat dit type in de rij" onderscheidt die twee gevallen zonder
       dat we ergens een uitzondering hoeven op te schrijven. */
    var series = {};
    var seriesVolgorde = [];
    Array.prototype.forEach.call(grid.querySelectorAll(CARD_SELECTOR), function (card) {
      var d = describe(card);
      var serie = d.group || ('los-' + card.getAttribute('data-product-handle'));
      if (!series[serie]) { series[serie] = []; seriesVolgorde.push(serie); }
      series[serie].push(d);
    });

    var buckets = {};
    var order = [];
    seriesVolgorde.forEach(function (serie) {
      var leden = series[serie];
      var gezien = [];
      leden.forEach(function (d) {
        if (d.type && rijTypes.indexOf(d.type) > -1 && gezien.indexOf(d.type) < 0) gezien.push(d.type);
      });

      if (gezien.length < 2) {
        buckets[serie] = leden;
        order.push(serie);
        return;
      }

      // Twee of meer aanklikbare soorten in één serie: uit elkaar halen.
      // Producten met een soort die niet in de rij staat, gaan bij de eerste
      // aanklikbare soort van hun serie - ze horen daar inhoudelijk bij en
      // zouden anders een eenzame kaart vormen.
      leden.forEach(function (d) {
        var soort = (d.type && rijTypes.indexOf(d.type) > -1) ? d.type : gezien[0];
        var key = serie + '::' + soort;
        if (!buckets[key]) { buckets[key] = []; order.push(key); }
        buckets[key].push(d);
      });
    });

    order.forEach(function (key) { renderGroup(buckets[key], cfg, filterMat); });

    // Het aantal klopte niet meer: "41 producten" boven een raster met 15
    // kaarten. Toon wat de bezoeker ziet, en wat eronder zit als toelichting.
    var teller = document.querySelector('[data-wwc-count]');
    if (teller) {
      var zichtbaar = document.querySelectorAll(CARD_SELECTOR + ':not([data-wwc-merged="hidden"])').length;
      var totaal = parseInt(teller.getAttribute('data-total'), 10) || zichtbaar;
      var woord = (cfg.labels && cfg.labels.products) || 'producten';
      teller.textContent = zichtbaar < totaal
        ? zichtbaar + ' ' + woord + ' · ' + totaal + ' ' + ((cfg.labels && cfg.labels.variants) || 'uitvoeringen')
        : totaal + ' ' + woord;
    }

    if (cfg.woodPicker) bouwHoutkiezer(cfg, filterMat);
    if (cfg.stickyTypes) volgScroll();

    // Raster mag zichtbaar worden: er valt niets meer in elkaar te klappen.
    var arming = grid.closest('[data-wwc-groups-arming]') || document.querySelector('[data-wwc-groups-arming]');
    if (arming) arming.removeAttribute('data-wwc-groups-arming');
    sortGroups(grid, cfg);
    orderTypeRow(section, cfg);
    renderInserts(grid, cfg, filterMat, typeSel);
    renderProductInserts(grid, filterMat, typeSel);
  }

  /* Volgorde van de kaarten. 'collection' laat Shopify's eigen volgorde en de
     sorteerkeuze van de klant met rust — daarom is dat de standaard. */
  // Heeft de klant zélf een sortering gekozen? Dan is dat leidend. Onze
  // voorkeursvolgorde mag niet met die keuze vechten; Shopify heeft de kaarten
  // dan al op prijs gezet, en omdat de goedkoopste van een groep de kaart
  // draagt staan de groepen daarmee vanzelf op hun laagste prijs.
  function klantKoosSortering() {
    return !!new URLSearchParams(window.location.search).get('sort_by');
  }

  /* De sorteerkeuze van de klant, of null. */
  function klantSortering() {
    return new URLSearchParams(window.location.search).get('sort_by');
  }

  function sortGroups(grid, cfg) {
    var mode = cfg.groupSort || 'collection';

    /* Sorteert de klant op prijs, dan moeten WIJ die volgorde bepalen.

       Shopify sorteert op de laagste variantprijs van het onderliggende
       kloonproduct, terwijl de kaart na samenvoegen de prijs van de goedkoopste
       kloon in de groep toont. Die twee lopen uiteen, en dus zag je op Utrecht
       bij "Prijs: laag naar hoog" een lijst met drie zichtbare breuken - een
       kaart van 31,95 tussen 24,95 en 24,95 in. Wie op prijs sorteert doet dat
       om een budget te bewaken; een lijst die dan niet klopt is erger dan geen
       sortering.

       Daarom hier de sortering opnieuw uitvoeren op de prijs die de kaart
       werkelijk laat zien. Bij elke andere sorteerkeuze blijven we van de
       volgorde af: dan weet Shopify het beter dan wij. */
    var keuze = klantSortering();
    if (keuze === 'price-ascending' || keuze === 'price-descending') {
      mode = (keuze === 'price-ascending') ? 'price-asc' : 'price-desc';
    } else {
      if (mode === 'collection') return;
      if (klantKoosSortering()) return;
    }

    var cards = Array.prototype.filter.call(grid.children, function (c) {
      return c.classList.contains('grid-product') && c.getAttribute('data-wwc-merged') !== 'hidden';
    });
    if (cards.length < 2) return;

    // Tolerant vergelijken: schrijf je 'Standing' in de instelling, dan moet
    // dat ook 'Standing Skyline' vinden. Langste treffer wint, anders pakt
    // 'Skyline' de Standing Skylines af.
    var volgorde = (cfg.typeOrder || []).map(function (t) { return t.toLowerCase(); });
    function rank(c) {
      var t = (c.getAttribute('data-wwc-type') || '').toLowerCase();
      if (!t) return 999;

      /* Eerst exact, pas daarna een deeltreffer - en dan maar in één richting.

         De oude test keek ook of de INSTELLING in het PRODUCTTYPE zat
         (`o.indexOf(t) > -1`). Daardoor matchte een gewone "Skyline" óók op de
         instelling "Standing Skyline": die bevat immers het woord skyline.
         Beide kaarten kregen dezelfde rang en hielden dus hun oorspronkelijke
         volgorde. Gemeten op Genemuiden stond Skyline vóór Standing Skyline
         terwijl de ingestelde volgorde het omgekeerde vraagt.

         Staat een type letterlijk in de lijst, dan is dat het antwoord. Alleen
         als dat niet zo is, zoeken we de langste instelling die ín het
         producttype voorkomt - zo blijft "Standing Skyline Shape" nog vallen
         onder een instelling "Standing Skyline", zonder dat het andersom gaat
         werken. */
      var exact = volgorde.indexOf(t);
      if (exact > -1) return exact;

      var beste = 999, langste = -1;
      volgorde.forEach(function (o, i) {
        if (o && t.indexOf(o) > -1 && o.length > langste) { langste = o.length; beste = i; }
      });
      return beste;
    }
    function low(c) { return parseInt(c.getAttribute('data-wwc-low') || c.getAttribute('data-wwc-price') || '0', 10); }
    function mats(c) { return (c.querySelectorAll('.wwc-swatch') || []).length; }

    cards.sort(function (a, b) {
      if (mode === 'price-asc') return low(a) - low(b);
      if (mode === 'price-desc') return low(b) - low(a);
      if (mode === 'materials') return mats(b) - mats(a) || low(a) - low(b);
      return rank(a) - rank(b) || mats(b) - mats(a);   // 'type'
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  }

  /* De producttype-rij komt uit Shopify's filtervolgorde. Merch bovenaan een
     stadscollectie is zelden wat je wilt, dus laten we 'm herschikken. */
  // Het aantal dat op een typekaartje staat (het <small>-element). Verborgen in
  // beeld, maar wel de enige plek waar het aantal per soort staat.
  function aantal(kaart) {
    var el = kaart.querySelector('small');
    return parseInt((el && el.textContent) || '0', 10) || 0;
  }

  function orderTypeRow(section, cfg) {
    var track = (section.querySelector ? section : document).querySelector('.wwc-visual-type-filter__track');
    if (!track || track.dataset.wwcOrdered === '1') return;

    var handmatig = cfg.typeOrder && cfg.typeOrder.length &&
                    cfg.typeOrder.join('').trim() !== '';

    // Geen handmatige lijst? Dan zelf een volgorde bepalen in plaats van niets
    // doen. Een lijst bijhouden voor elke productsoort in elke stad is niet vol
    // te houden; het aantal producten per soort is een bruikbare maatstaf voor
    // wat de winkel aanbiedt, en staat al op elk kaartje. Meeste aanbod vooraan.
    if (!handmatig) {
      var kaartjes = Array.prototype.filter.call(track.children, function (c) {
        return c.getAttribute('data-wwc-product-filter');
      });
      if (kaartjes.length < 2) return;
      kaartjes.sort(function (a, b) { return aantal(b) - aantal(a); });
      kaartjes.forEach(function (c) { track.appendChild(c); });
      track.dataset.wwcOrdered = '1';
      return;
    }

    var rank = {};
    cfg.typeOrder.forEach(function (t, i) { rank[t.toLowerCase()] = i; });

    var cards = Array.prototype.filter.call(track.children, function (c) {
      return c.getAttribute('data-wwc-product-filter');   // lege waarde = geen productsoort
    });
    // De knop bevat het label én het aantal ("Klok 15"); dat cijfer moet eraf,
    // anders matcht er niets. De filterwaarde is geen alternatief — sommige
    // types dragen daar een gid:// in plaats van hun naam.
    function label(el) {
      return (el.textContent || '').replace(/[\s\d]+$/, '').trim().toLowerCase();
    }
    cards.sort(function (a, b) {
      var ra = rank[label(a)], rb = rank[label(b)];
      return (ra === undefined ? 999 : ra) - (rb === undefined ? 999 : rb);
    });
    cards.forEach(function (c) { track.appendChild(c); });
    track.dataset.wwcOrdered = '1';
  }

  // Onze eigen wijzigingen zetten ook de observer aan het werk; deze vlag
  // voorkomt dat we onszelf in een lus praten.
  /* ── Introregel: "lees meer" ────────────────────────────────────────────
     De knop staat er in Liquid al, ook zonder JS. Zonder JS klapt hij niet
     open, maar dan is de eerste regel er nog steeds en staat de volledige
     tekst gewoon in de HTML — leesbaar voor een zoekmachine en voor een
     schermlezer. Daarom kappen we de rest af met CSS en niet met display:none.

     De klik loopt via één gedelegeerde luisteraar op document, niet via een
     luisteraar per blok. Dat is niet netter maar noodzakelijk: de vorige opzet
     bond de klik tijdens het opbouwen en zette daarbij een vlag op het element.
     Viel die eerste ronde te vroeg — of verving het thema het blok daarna —
     dan bleef de vlag staan terwijl de luisteraar er niet was, en deed "Lees
     meer" precies niets. Gemeten: het blok was geïnitialiseerd, de knop stond
     zichtbaar, en een klik veranderde niets. Met delegatie bestaat die
     toestand niet. */
  function minderLabel(t) {
    return t.replace(/meer|more|suite|mehr/i, function (w) {
      return { meer: 'minder', more: 'less', suite: 'moins', mehr: 'weniger' }[w.toLowerCase()] || w;
    });
  }

  var introGebonden = false;

  function introKlaar() {
    if (!introGebonden) {
      introGebonden = true;
      document.addEventListener('click', function (e) {
        var knop = e.target && e.target.closest ? e.target.closest('[data-wwc-intro-meer]') : null;
        if (!knop) return;
        var blok = knop.closest('[data-wwc-intro]');
        if (!blok) return;
        e.preventDefault();
        var uit = blok.classList.toggle('is-open');
        knop.setAttribute('aria-expanded', uit ? 'true' : 'false');
        knop.textContent = uit ? knop.getAttribute('data-minder') : knop.getAttribute('data-meer');
      });
    }

    document.querySelectorAll('[data-wwc-intro]').forEach(function (blok) {
      var knop = blok.querySelector('[data-wwc-intro-meer]');
      var tekst = blok.querySelector('.wwc-collectie-intro__tekst');
      if (!knop || !tekst) return;

      if (!knop.getAttribute('data-meer')) {
        var label = knop.textContent.trim();
        knop.setAttribute('data-meer', label);
        knop.setAttribute('data-minder', minderLabel(label));
      }

      // Past de hele tekst al op die ene regel? Dan heeft de knop niets te
      // bieden. Meten op BREEDTE: ingeklapt is het één regel met puntjes, dus
      // de hoogte is altijd één regel — ook met drie alinea's erachter.
      // Nooit verbergen terwijl hij openstaat; dan is de knop de weg terug.
      if (!blok.classList.contains('is-open')) {
        knop.hidden = tekst.scrollWidth <= tekst.clientWidth + 2;
      }
    });
  }

  /* ── Typerij: veeg zichtbaar maken ──────────────────────────────────────
     Drie aanwijzingen, en alle drie alleen als er écht iets buiten beeld
     staat. Een vervaging over een rij die al helemaal past, of een balkje dat
     de volle breedte vult, zegt "je bent er al" — dat is ruis die de bezoeker
     leert de aanwijzing te negeren.

     De hoogte van de vervaging wordt op het beeldvlak gezet, niet op het hele
     spoor: over de labels heen zou hij het laatste woord onleesbaar maken in
     plaats van het volgende plaatje aan te kondigen. */
  function typerijKlaar() {
    document.querySelectorAll('.wwc-visual-type-filter').forEach(function (rij) {
      var spoor = rij.querySelector('.wwc-visual-type-filter__track');
      if (!spoor) return;

      var rand = rij.__wwcRand;
      var baan = rij.__wwcBaan;
      var duim = rij.__wwcDuim;

      if (!rand) {
        rand = document.createElement('span');
        rand.className = 'wwc-typerij-rand';
        rand.setAttribute('aria-hidden', 'true');
        rij.appendChild(rand);

        baan = document.createElement('div');
        baan.className = 'wwc-typerij-baan';
        baan.setAttribute('aria-hidden', 'true');
        duim = document.createElement('i');
        duim.className = 'wwc-typerij-duim';
        baan.appendChild(duim);
        spoor.insertAdjacentElement('afterend', baan);

        rij.__wwcRand = rand; rij.__wwcBaan = baan; rij.__wwcDuim = duim;
        spoor.addEventListener('scroll', teken, { passive: true });
        window.addEventListener('resize', teken);
      }

      function teken() {
        var over = spoor.scrollWidth - spoor.clientWidth;
        var teVegen = over > 8;

        rand.hidden = !teVegen;
        baan.hidden = !teVegen;
        var hint = rij.querySelector('[data-wwc-veeg-hint]');
        if (hint) hint.hidden = !teVegen;
        if (!teVegen) return;

        // Vervaging alleen over het beeld, niet over de labels.
        var kaart = spoor.querySelector('.wwc-visual-type-card__image');
        rand.style.top = '0px';
        rand.style.height = ((kaart ? kaart.offsetHeight : 70) + 4) + 'px';

        var deel = Math.max(.14, spoor.clientWidth / spoor.scrollWidth);
        var pos = spoor.scrollLeft / over;
        duim.style.width = (deel * 100) + '%';
        duim.style.transform = 'translateX(' + (pos * (1 - deel) * (baan.clientWidth || 1)) + 'px)';

        rij.classList.toggle('is-aan-eind', spoor.scrollLeft >= over - 2);
      }

      /* Na filteren staat het gekozen kaartje vaak buiten beeld: je tikt op
         "Citymap" aan de rechterrand, de pagina laadt opnieuw en de rij begint
         weer helemaal links. Dan zie je niet meer waar je bent. Daarom het
         actieve kaartje in beeld schuiven — direct toewijzen en niet met
         behavior:'smooth', want dat komt in een horizontaal spoor onbetrouwbaar
         aan. Alleen bij het opbouwen, nooit tijdens het vegen. */
      if (!rij.__wwcGericht) {
        rij.__wwcGericht = true;
        var actief = spoor.querySelector('.wwc-visual-type-card.is-active');
        if (actief) {
          // Alleen schuiven als het gekozen kaartje écht buiten beeld staat.
          // Eerst schoof de rij altijd naar het midden, ook als je kaartje al
          // vooraan stond — en dat is precies het verspringen dat je ziet zodra
          // je op een filter tikt: de pagina laadt, de rij staat links, en een
          // fractie later springt hij opzij zonder dat er iets gewonnen wordt.
          var links = actief.offsetLeft - spoor.scrollLeft;
          var rechts = links + actief.offsetWidth;
          if (links < 0 || rechts > spoor.clientWidth) {
            var doel = actief.offsetLeft - Math.max(0, (spoor.clientWidth - actief.offsetWidth) / 2);
            spoor.scrollLeft = Math.max(0, doel);
          }
        }
      }

      rij.__wwcTeken = teken;
      teken();
      // De foto's zijn lazy; zodra ze binnen zijn verandert scrollWidth niet,
      // maar de hoogte van het beeldvlak wel. Eén keer nameten is genoeg.
      spoor.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', teken, { once: true });
      });
    });
  }

  /* ── Raster of lijst ────────────────────────────────────────────────────
     De keuze wordt bewaard, want wie eenmaal voor lijst kiest wil dat op de
     volgende stad ook. Bewust in localStorage en niet in de URL: het is een
     voorkeur van de bezoeker, geen eigenschap van de pagina — je wilt niet dat
     iemand een link deelt en de ander een lijst krijgt omdat de deler dat
     prettig vond.

     De klasse komt op de rasterhouder en niet op de body, zodat er niets
     verandert aan pagina's die deze module niet gebruiken. */
  /* Bewust een nieuwe sleutel.

     De vorige versie schreef de standaard bij élke paginalading weg. Iedereen
     die de pagina in die periode bezocht heeft, heeft daardoor 'raster' in zijn
     browser staan zonder er ooit voor gekozen te hebben - en dat zou de nieuwe
     mobiele standaard permanent blokkeren. Getest in de simulator: ook na de
     reparatie bleef die telefoon in raster staan, precies om die reden.

     Door de sleutel te hernoemen worden die oude waarden genegeerd. Iedereen
     krijgt de standaard die bij zijn scherm hoort, en vanaf nu wordt alleen nog
     een echte klik bewaard. */
  var WEERGAVE_SLEUTEL = 'wwc:weergave2';

  function bewaardeWeergave() {
    /* Standaard verschilt per scherm: op een telefoon lijst, op een groot
       scherm raster.

       Reden: in twee kolommen op 390px is een productfoto ongeveer 170px breed
       en past er anderhalf product op een scherm. In de lijst is de foto 150px
       en staan titel, feiten en prijs ernaast in plaats van eronder, dus zie je
       er drie tot vier. Voor een winkel waar de bezoeker gemiddeld anderhalf
       scherm ver komt, is dat het verschil tussen vier producten zien en tien.

       Zodra iemand zelf wisselt, is dat leidend - ook op zijn telefoon, en ook
       op de volgende stad. De opgeslagen keuze wint dus altijd van de standaard. */
    try {
      var keuze = localStorage.getItem(WEERGAVE_SLEUTEL);
      if (keuze) return keuze;
    } catch (e) {}
    /* Grens op 600px en niet op 749px.

       Gemeten op een iPad mini: die meldt 744 CSS-pixels in portret en viel
       daarmee aan de telefoonkant, dus kreeg hij standaard de lijst. Op een
       scherm van 744px passen twee kolommen prima en dan zie je meer producten
       per scherm dan in een lijst - precies omgekeerd aan de reden waarom de
       lijst op een telefoon wint. De 749px-grens hoort bij de opmaak, niet bij
       deze keuze; hier telt hoeveel kolommen zinvol zijn. */
    return window.matchMedia && window.matchMedia('(max-width: 599px)').matches ? 'lijst' : 'raster';
  }

  function zetWeergave(modus, bewaren) {
    document.querySelectorAll('.product-grid-container, [data-wwc-grid-shell]').forEach(function (g) {
      g.classList.toggle('wwc-lijst', modus === 'lijst');
    });
    document.querySelectorAll('[data-wwc-view-toggle]').forEach(function (b) {
      b.classList.toggle('is-lijst', modus === 'lijst');
      b.setAttribute('aria-pressed', modus === 'lijst' ? 'true' : 'false');
    });
    /* Alleen opslaan als de bezoeker zélf gekozen heeft.

       Hiervoor schreef deze functie de waarde bij élke paginalading weg, ook
       wanneer hij alleen de standaard toepaste. Gevolg: iedereen die de pagina
       ooit bezocht had, had 'raster' opgeslagen staan zonder er ooit op te
       hebben geklikt - en die opgeslagen waarde won daarna van de nieuwe
       mobiele standaard. De standaard bereikte die bezoekers dus nooit meer.

       Even belangrijk: zolang je de standaard opslaat, is achteraf niet meer te
       zien wat een keuze was en wat een aanname. */
    if (bewaren) {
      try { localStorage.setItem(WEERGAVE_SLEUTEL, modus); } catch (e) {}
    }
  }

  var weergaveGebonden = false;

  function weergaveKlaar() {
    zetWeergave(bewaardeWeergave(), false);
    if (weergaveGebonden) return;
    weergaveGebonden = true;
    document.addEventListener('click', function (e) {
      var knop = e.target && e.target.closest ? e.target.closest('[data-wwc-view-toggle]') : null;
      if (!knop) return;
      e.preventDefault();
      zetWeergave(bewaardeWeergave() === 'lijst' ? 'raster' : 'lijst', true);
    });
  }

  var busy = false;
  var timer = null;

  function boot() {
    if (busy) return;
    busy = true;
    try {
      document.querySelectorAll('[data-wwc-groups-config]').forEach(function (el) {
        var section = el.closest('.shopify-section, [data-section-id]') || document;
        run(section);
      });
      // Los van de groepsmodule: deze twee horen bij de pagina, niet bij een
      // ingeschakelde instelling, en moeten dus ook draaien als run() afhaakt.
      introKlaar();
      typerijKlaar();
      try {
        if (sessionStorage.getItem('wwc:naar-boven')) {
          sessionStorage.removeItem('wwc:naar-boven');
          window.scrollTo(0, 0);
        }
      } catch (e) {}
      weergaveKlaar();
    } finally {
      busy = false;
    }
  }

  function bootSoon() {
    clearTimeout(timer);
    timer = setTimeout(boot, 60);
  }

  function watch() {
    boot();

    // wwc-collection.js hangt z'n pills er ná ons in. Zodra dat gebeurd is,
    // laten we elke groepskaart z'n materiaal opnieuw doorgeven.
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        document.querySelectorAll('.grid-product[data-wwc-group]').forEach(function (c) {
          if (typeof c.__wwcFit === 'function') c.__wwcFit();
        });
      }, 120);
    });

    document.addEventListener('wwc:cards-enhanced', function () {
      document.querySelectorAll('.grid-product[data-wwc-group]').forEach(function (c) {
        if (typeof c.__wwcSync === 'function') c.__wwcSync();
        // De pills komen er nu pas bij; die duwen de rij en veranderen de
        // beschikbare breedte, dus opnieuw uitrekenen.
        if (typeof c.__wwcFit === 'function') c.__wwcFit();
      });
    });

    // Het thema vervangt of vult de grid aan bij filteren, sorteren en
    // 'laad meer'. We kijken naar de grid zelf i.p.v. te leunen op een
    // signaal, zodat de module los staat van wwc-collection.js.
    document.querySelectorAll('.product-grid-container, [data-wwc-grid-shell]').forEach(function (grid) {
      new MutationObserver(bootSoon).observe(grid, { childList: true });
    });

    ['collection:reloaded', 'page:loaded', 'shopify:section:load'].forEach(function (evt) {
      document.addEventListener(evt, bootSoon);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }

  // Voor tests in node.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { materialClass: materialClass, orderIndex: orderIndex, sortOptions: sortOptions, pickHero: pickHero, minPrice: minPrice };
  }
})();
